export default "/assets/images/purely-white-sm.3769d0899ae7cdd9.jpg";